import { useRef } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://app.alpenscreen.ch/api';

export const usePlayerAnalytics = (screenUuid) => {
  const currentContentViewId = useRef(null);
  const contentViewStartTime = useRef(null);

  const trackContentViewStart = async (item) => {
    // Falls bereits ein View läuft, beende ihn erst
    if (currentContentViewId.current) {
      await endCurrentContentView();
    }

    try {
      const payload = {
        screenUuid,
        playlistId: item.playlist_id || null,
        playlistItemId: item.id || null,
        mediaId: item.item_type === 'media' ? item.media_id : null,
        widgetId: item.item_type === 'widget' ? item.widget_instance_id : null
      };

      const response = await axios.post(
        `${API_BASE_URL}/analytics/public/track/content-view`,
        payload
      );

      if (response.data.success) {
        currentContentViewId.current = response.data.contentViewId;
        contentViewStartTime.current = Date.now();

        console.log('📊 Content view started:', {
          contentViewId: response.data.contentViewId,
          itemType: item.item_type,
          name: item.name
        });
      }
    } catch (error) {
      console.error('Failed to track content view start:', error);
    }
  };

  const endCurrentContentView = async () => {
    if (!currentContentViewId.current || !contentViewStartTime.current) {
      return;
    }

    try {
      const durationSeconds = Math.floor((Date.now() - contentViewStartTime.current) / 1000);
      
      await axios.post(
        `${API_BASE_URL}/analytics/public/track/content-view/${currentContentViewId.current}/end`,
        { durationSeconds }
      );

      console.log('📊 Content view ended:', {
        contentViewId: currentContentViewId.current,
        durationSeconds
      });

      currentContentViewId.current = null;
      contentViewStartTime.current = null;
    } catch (error) {
      console.error('Failed to end content view:', error);
    }
  };

  const trackWidgetUsage = async (widget, eventType = 'viewed', metadata = {}) => {
    try {
      // ✅ FIX: Versuche alle möglichen widget_id Properties
      const widgetId = widget.widget_instance_id 
                    || widget.feature_instance_id 
                    || widget.id 
                    || widget.widget_id
                    || null;
      
      // ✅ Debug log - zeigt welche Properties verfügbar sind
      console.log('📊 trackWidgetUsage called with:', {
        widgetId,
        widget_instance_id: widget.widget_instance_id,
        feature_instance_id: widget.feature_instance_id,
        id: widget.id,
        feature_id: widget.feature_id,
        name: widget.name
      });
      
      await axios.post(
        `${API_BASE_URL}/analytics/public/track/widget-usage`,
        {
          screenUuid,
          widgetId, // ✅ Verwendet jetzt die gefundene ID
          widgetType: widget.feature_id,
          eventType,
          metadata: {
            name: widget.name,
            config: widget.config,
            ...metadata
          }
        }
      );

      console.log('📊 Widget usage tracked:', {
        widgetType: widget.feature_id,
        widgetId, // ✅ Zeige welche ID verwendet wurde
        eventType
      });
    } catch (error) {
      console.error('Failed to track widget usage:', error);
    }
  };

  const cleanup = async () => {
    await endCurrentContentView();
  };

  return {
    trackContentViewStart,
    endCurrentContentView,
    trackWidgetUsage,
    cleanup
  };
};